import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import flatten from 'flat';

import { LocaleContextProvider } from '../localeContextProvider/LocaleContextProvider';
import { Locale, UpdateLocale } from '../localeContext/localeContext.types';

import enTranslations from 'locale/en.json';
import { LocaleContextControllerProps, LocaleData } from './LocaleContextController.types';

const defaultLocaleData: LocaleData = {
  en: flatten<object, { [key: string]: string }>(enTranslations),
};

export const LocaleContextController: React.FC<LocaleContextControllerProps> = ({
  children,
  localeData = defaultLocaleData,
}) => {
  const [locale, setLocale] = useState<Locale>(Locale.en);
  const messages = localeData[locale];

  const updateLocale: UpdateLocale = nextLocale => setLocale(nextLocale);

  return (
    <IntlProvider locale={locale} messages={messages}>
      <LocaleContextProvider updateLocale={updateLocale}>{children}</LocaleContextProvider>
    </IntlProvider>
  );
};
